import React, { useRef, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../../../../components/hooks/useAuth";
import Loader from "../../../../../components/Loader";

const ModalCriarGrupo = ({
  setModalCriarGrupo, modalCriarGrupo, loadGroupRequest, campaignId
}) => {


  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [maxMembers, setMaxMember] = useState(256);
  const [restrictAnnouncementtype, setRestrictAnnouncementtype] = useState(false);
  const [ephemeralHours, setEphemeralHours] = useState(0);

  const [newAdmins, setNewAdmins] = useState([]);

  const [newAdmName, setNewAdmName] = useState("");
  const [newAdmPhoneNumber, setNewAdmPhoneNumber] = useState("");
  const [pictureBase64, setPictureBase64] = useState(null); // pode ser url ou cor


  const [abaModal, setAbaModal] = useState("detalhes"); // "detalhes" ou "admins"
  const [modalNovoAdmin, setModalNovoAdmin] = useState(false);
  const inputCapaRef = useRef(null);
  const { sidebarOpen, getApi, postApi } = useAuth();

  const [loadingOperation, setLoadingOperation] = useState(false);
  const [countryCode, setCountryCode] = useState("55");

  const addAdminAction = () => {
    if (newAdmName && newAdmPhoneNumber) {
      const phoneNumberClean = newAdmPhoneNumber.replace(/\D/g, "");
      const newAdminEntry = {
        name: newAdmName,
        phone_number: `55${phoneNumberClean}`
      };
      setNewAdmins([...newAdmins, newAdminEntry]);
      setNewAdmName("");
      setNewAdmPhoneNumber("");
      setModalNovoAdmin(false);
    } else {
      window.alert("Você precisa informar o Nome e Nº Telefone.")
    }
  };

  const removeAdminAction = (index) => {
    setNewAdmins(newAdmins.filter((_, i) => i !== index));
  };

  const formatarNumeroCelular = (numero) => {
    return numero
      .replace(/\D/g, "") // Remove tudo que não for dígito
      .replace(/^(\d{2})(\d)/, "($1) $2") // Adiciona parênteses no DDD
      .replace(/(\d{5})(\d)/, "$1-$2") // Adiciona o hífen após o quinto dígito
      .slice(0, 15); // Limita o tamanho máximo
  };



  const createGroupRequest = async () => {
    if (maxMembers > 1000) {
      alert("O limite de pessoas em grupo é de até 1000");
      return;
    }
    setLoadingOperation(true);
    try {
      let response = await postApi("/api/v1/campaign/groups/create/" + campaignId, {
        'name': groupName,
        'description': groupDescription,
        'max_members': maxMembers,
        'restrict_announcement_type': restrictAnnouncementtype ? "announcement" : "not_announcement",
        'new_admins': newAdmins,
        'picture_base64': pictureBase64,
        'invite_enabled': true,
        'ephemeral_hours': ephemeralHours
      });
    } catch (error) {
      window.alert("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoadingOperation(false);
      loadGroupRequest();
      setModalCriarGrupo(false)
    }
  }

  if (!modalCriarGrupo) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.4)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 18,
        padding: 0,
        minWidth: 320,
        maxWidth: 400,
        width: "95vw",
        maxHeight: "90vh",
        boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <h2 style={{
          color: "#005c53",
          margin: "24px 0 0 0",
          fontWeight: "bold",
          width: "100%",
          textAlign: "center"
        }}>Criação de grupos</h2>
        {/* Círculo da capa */}
        <div style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          margin: "18px 0 0 0"
        }}>
          <div style={{
            width: 110,
            height: 110,
            borderRadius: "50%",
            background: pictureBase64 ? `url(${pictureBase64}) center/cover` : "#51a197",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 38,
            color: "#fff",
            fontWeight: "bold",
            overflow: "hidden",
            position: "relative"
          }}>
            {!pictureBase64 && "G"}
            {/* Ícone editar */}
            <button
              style={{
                position: "absolute",
                bottom: 8,
                right: 44,
                background: "#fff",
                border: "2px solid #51a197",
                borderRadius: "50%",
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)"
              }}
              title="Editar capa"
              onClick={() => inputCapaRef.current && inputCapaRef.current.click()}
            >
              <FaEdit color="#51a197" size={18} />
            </button>
            {/* Input file escondido */}
            <input
              type="file"
              accept="image/*"
              ref={inputCapaRef}
              style={{ display: "none" }}
              onChange={e => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = ev => { setPictureBase64(ev.target.result); };

                  reader.readAsDataURL(file);
                }
              }}
            />
            {/* Ícone excluir */}
            <button
              style={{
                position: "absolute",
                bottom: 8,
                right: 0,
                background: "#fff",
                border: "2px solid #e74c3c",
                borderRadius: "50%",
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)"
              }}
              title="Excluir capa"
              onClick={() => setPictureBase64(null)}
            >
              <FaTrash color="#e74c3c" size={18} />
            </button>
          </div>
        </div>
        {/* Conteúdo rolável */}
        <div style={{
          width: "100%",
          padding: "24px 24px 16px 24px",
          overflowY: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          boxSizing: "border-box"
        }}>
          {/* Abas do modal */}
          <div style={{
            width: "100%",
            display: "flex",
            borderBottom: "1px solid #e0e0e0",
            marginBottom: 18,
            marginTop: 12
          }}>
            <button
              onClick={() => setAbaModal("detalhes")}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                borderBottom: abaModal === "detalhes" ? "3px solid #51a197" : "none",
                color: abaModal === "detalhes" ? "#51a197" : "#333",
                fontWeight: "bold",
                fontSize: 16,
                padding: "10px 0",
                cursor: "pointer"
              }}
            >
              Detalhes do Grupo
            </button>
            <button
              onClick={() => setAbaModal("admins")}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                borderBottom: abaModal === "admins" ? "3px solid #51a197" : "none",
                color: abaModal === "admins" ? "#51a197" : "#333",
                fontWeight: "bold",
                fontSize: 16,
                padding: "10px 0",
                cursor: "pointer"
              }}
            >
              Administradores
            </button>
          </div>
          {/* Conteúdo das abas */}
          {abaModal === "detalhes" && (
            <div style={{ width: "100%" }}>
              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Nome do grupo</label>
              <input
                type="text"
                value={groupName}
                onChange={e => setGroupName(e.target.value)}
                placeholder="Digite o nome do grupo"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />

              {/* Apenas admins enviam mensagem ao grupo */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: "bold", color: "#333", marginBottom: 8, display: "block" }}>
                  Apenas admins enviam mensagem ao grupo
                </label>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <label style={{ position: "relative", display: "inline-block", width: 50, height: 24 }}>
                    <input
                      type="checkbox"
                      style={{ opacity: 0, width: 0, height: 0 }}
                      onChange={e => setRestrictAnnouncementtype(e.target.checked)}
                      checked={restrictAnnouncementtype}
                    />
                    <span style={{
                      position: "absolute",
                      cursor: "pointer",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: restrictAnnouncementtype ? "#51a197" : "#ccc",
                      borderRadius: 24,
                      transition: "0.4s"
                    }}></span>
                    <span style={{
                      position: "absolute",
                      content: '""',
                      height: 18,
                      width: 18,
                      left: restrictAnnouncementtype ? 28 : 4,
                      bottom: 3,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      transition: "0.4s"
                    }}></span>
                  </label>
                </div>
              </div>



              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Descrição do grupo</label>
              <textarea
                value={groupDescription}
                onChange={e => setGroupDescription(e.target.value)}
                placeholder="Digite a descrição do grupo"
                rows={6}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  resize: "vertical",
                  minHeight: 120,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />
              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Limite de pessoas</label>
              <input
                type="number"
                value={maxMembers}
                onChange={e => setMaxMember(e.target.value)}
                placeholder="Digite o limite de pessoas"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />

              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Mensagem Temporária</label>
              <select
                value={ephemeralHours}
                onChange={(e) => setEphemeralHours(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              >
                <option value={0}>Desativado</option>
                <option value={86400}>24h</option>
                <option value={604800}>7 dias</option>
                <option value={7776000}>90 dias</option>
              </select>



              <div style={{
                display: "flex",
                gap: 16,
                marginTop: 12,
                width: "100%",
                justifyContent: "flex-end"
              }}>
                <button
                  onClick={e => createGroupRequest()}
                  disabled={loadingOperation}
                  style={{
                    background: "#51a197",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 28px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer"
                  }}
                >
                  Salvar
                </button>
                <button
                  style={{
                    background: "#e0e0e0",
                    color: "#005c53",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 28px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer"
                  }}
                  disabled={loadingOperation}
                  onClick={() => setModalCriarGrupo(false)}
                >
                  Cancelar
                </button>
              </div>

              {loadingOperation && <Loader />}
            </div>
          )}
          {abaModal === "admins" && (
            <div style={{ width: "100%" }}>
              <h3 style={{ fontWeight: "bold", color: "#005c53", marginBottom: 12 }}>Administradores</h3>
              {newAdmins.map((admin, index) => (
                <div key={index} style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f6f6f6",
                  padding: "10px 14px",
                  borderRadius: 8,
                  marginBottom: 8
                }}>
                  <span style={{ fontWeight: "bold", color: "#333" }}>{admin.name} - {admin.phone_number}</span>
                  <button
                    onClick={() => removeAdminAction(index)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#e74c3c",
                      cursor: "pointer"
                    }}
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}
              <button
                onClick={() => setModalNovoAdmin(true)}
                style={{
                  width: "100%",
                  background: "#51a197",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 14px",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer",
                  marginTop: 12
                }}
              >
                Adicionar Administrador
              </button>
            </div>
          )}
        </div>
      </div>
      {modalNovoAdmin && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <div style={{
            background: "#fff",
            borderRadius: 8,
            padding: 24,
            width: "90%",
            maxWidth: 400,
            boxShadow: "0 2px 16px rgba(0,0,0,0.18)"
          }}>
            <h3 style={{ fontWeight: "bold", color: "#005c53", marginBottom: 16 }}>Novo Administrador</h3>
            <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Nome</label>
            <input
              type="text"
              value={newAdmName}
              onChange={e => setNewAdmName(e.target.value)}
              placeholder="Digite o nome"
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #51a197",
                fontSize: 16,
                marginBottom: 16
              }}
            />
            <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Número</label>

            <div style={{ display: "flex", gap: "8px", marginBottom: 16 }}>
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                style={{
                  width: "80px",
                  padding: "10px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  backgroundColor: "#fff",
                  fontSize: 16
                }}
              >
                <option value="55">+55</option>
              </select>
              <input
                type="text"
                value={newAdmPhoneNumber}
                onChange={e => setNewAdmPhoneNumber(formatarNumeroCelular(e.target.value))}
                placeholder="Digite o número"
                style={{
                  flex: 1,
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                }}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
              <button
                onClick={addAdminAction}
                style={{
                  background: "#51a197",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 14px",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer"
                }}
              >
                Adicionar
              </button>
              <button
                onClick={() => setModalNovoAdmin(false)}
                style={{
                  background: "#e0e0e0",
                  color: "#005c53",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 14px",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer"
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalCriarGrupo;